
export default class MoRStatusModel {
    siteName: string = "";
    totalNetIncome: number = 0;
    totalIncome: number  = 0;
    totalIncomeCardPointe: number | null = null;
    merchantId: string = "";

    static from(json: string): MoRStatusModel {
        let model = Object.assign(new MoRStatusModel(), json);
                
        return model;
    }
}